import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DefaultLocale, LocalesArray } from './models/locales';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root',
})
export class CMSLanguageService {
  activeCMSLanguage$ = new BehaviorSubject(this.getLocaleId(this.translocoService.getActiveLang()));

  constructor(private translocoService: TranslocoService) {}

  get activeCMSLanguage(): string {
    return this.activeCMSLanguage$.value;
  }

  set activeCMSLanguage(lang: string) {
    this.activeCMSLanguage$.next(this.getLocaleId(lang));
  }

  getLocaleId(lang: string): string {
    const cmsLocale = LocalesArray.find(locale => locale.shorthand === lang);

    if (cmsLocale) {
      return cmsLocale.shorthand;
    }

    return DefaultLocale.shorthand;
  }
}
